const actionTypes = {
  SET_CANCEL_TEXT: 'commonConfirmModalSetCancelText',
  SET_CONFIRM_TEXT: 'commonConfirmModalSetConfirmText',

  SET_CONFIRM_MODAL_STATUS: 'commonConfirmModalSetConfirmModalStatus',
  SET_CONFIRM_MODAL_TEXT: 'commonConfirmModalSetConfirmModalText',
  SET_CALLBACK_TO_CONFIRM_MODAL: 'commonConfirmModalSetCallback',
  USE_CALLBACK: 'conmmonConfirmModalUseCallback',

  SET_USE_SINGLE_BUTTON_STATUS: 'commonConfirmModalSetUseSingleButtonStatus',
  SET_SINGLE_BUTTON_WIDTH: 'commonConfirmModalSetSingleButtonWidth',
}

export default actionTypes
